import axios from "axios";
import {getAuthorization} from "./util.service";
import {APIEndpoint} from "./auth.service";

export const APIEnpoint = {
  myApps: "/api/app/personal/search",
  genDownloadApp: "/api/app/personal/install",
  downloadLink: "/api/app/personal/download",
  Applications: "/api/v1/applications",
  CustomMenu: "/api/v1/custom-menu/",
  Orgs:"/api/org/member"
};

export const getCustomMenu = () => {
  return axios
      .get(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEnpoint.CustomMenu, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => res.data)
}